import {parse, differenceInDays, differenceInMinutes, differenceInHours} from 'date-fns';

import {DateFormatEnum} from 'presentation/constants';

const MIN_HOURS_TO_CONFIRM_SURGERY = 48;

export function checkConfirmAppointment(date: string, isSurgery?: boolean) {
	const referenceDate = new Date();
	const appointmentDate = parse(date, DateFormatEnum.DATE_FORMAT_1, new Date());

	if (isSurgery) {
		return differenceInHours(appointmentDate, referenceDate) >= MIN_HOURS_TO_CONFIRM_SURGERY;
	}

	const showConfirmToGo =
		differenceInDays(appointmentDate, referenceDate) <= 2 &&
		differenceInMinutes(appointmentDate, referenceDate) > 0;

	return showConfirmToGo;
}
